import { lazy } from 'react'

export default {
    path: '/dettagli/:dettaglioId',
    title: 'Dettaglio: {{params.dettaglioId}}',
    component: lazy(() => import('./detail'))
}